import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../utility';

const initialState = {
    currentRole: 'Select your functional area',
    currentTxtRole: 'Select your functional area',
    EXISTING_ROLES: [
        {
            English: 'Select your functional area',
            German: 'Funktion auswählen',
            French: 'Quel poste occupez-vous ?',
            Russian: 'Выберите свою роль',
            Turkish: 'Görevinizi Seçin',
            Italian: 'Seleziona il tuo ruolo',
            Spanish: 'Seleccione su cargo',
            PortugueseBR: 'Selecione sua função',
            SpanishLAD: 'Selecciona tu cargo'
        },
        {
            English: 'Virtual Seller',
            German: 'CFO',
            French: 'Directeur financier et administratif',
            Russian: 'Директор финансового департамента',
            Turkish: 'CFO',
            Italian: 'CFO',
            Spanish: 'CFO',
            PortugueseBR: 'CFO',
            SpanishLAD: 'CFO'
        },     
         {
            English: 'Sales Manager',
            German: 'VP oder Direktor Finanzplanung und Analysen',
            French: 'Vice-Président ou Directeur de la planification et de l’analyse financière',
            Russian: 'Вице-президент или директор по финансовому планированию и анализу',
            Turkish: 'BY veya FP&A Müdürü',
            Italian: 'VP o Responsabile Pianificazione & Controllo di Gestione, Group Controller',
            Spanish: 'VP o director de planificación y análisis financieros',
            PortugueseBR: 'Vice-presidente ou Diretor de FP&A',
            SpanishLAD: 'Vicepresidente o Director de FP&A'
        },  
        {
            English: 'Sales Executive',
            German: 'VP oder Direktor Finanzplanung und Analysen',
            French: 'Vice-Président ou Directeur de la planification et de l’analyse financière',
            Russian: 'Вице-президент или директор по финансовому планированию и анализу',
            Turkish: 'BY veya FP&A Müdürü',
            Italian: 'VP o Responsabile Pianificazione & Controllo di Gestione, Group Controller',
            Spanish: 'VP o director de planificación y análisis financieros',
            PortugueseBR: 'Vice-presidente ou Diretor de FP&A',
            SpanishLAD: 'Vicepresidente o Director de FP&A'
        }, 
        {
            English: 'Head of Digital and Ecommerce',
            German: 'VP oder Direktor Finanzplanung und Analysen',
            French: 'Vice-Président ou Directeur de la planification et de l’analyse financière',
            Russian: 'Вице-президент или директор по финансовому планированию и анализу',
            Turkish: 'BY veya FP&A Müdürü',
            Italian: 'VP o Responsabile Pianificazione & Controllo di Gestione, Group Controller',
            Spanish: 'VP o director de planificación y análisis financieros',
            PortugueseBR: 'Vice-presidente ou Diretor de FP&A',
            SpanishLAD: 'Vicepresidente o Director de FP&A'
        }, 
        {
            English: 'CPQ and Sales Operations',
            German: 'VP oder Direktor Finanzplanung und Analysen',
            French: 'Vice-Président ou Directeur de la planification et de l’analyse financière',
            Russian: 'Вице-президент или директор по финансовому планированию и анализу',
            Turkish: 'BY veya FP&A Müdürü',
            Italian: 'VP o Responsabile Pianificazione & Controllo di Gestione, Group Controller',
            Spanish: 'VP o director de planificación y análisis financieros',
            PortugueseBR: 'Vice-presidente ou Diretor de FP&A',
            SpanishLAD: 'Vicepresidente o Director de FP&A'
        },
        {
            English: 'Revenue Management',
            German: 'VP oder Direktor Finanzplanung und Analysen',
            French: 'Vice-Président ou Directeur de la planification et de l’analyse financière',
            Russian: 'Вице-президент или директор по финансовому планированию и анализу',
            Turkish: 'BY veya FP&A Müdürü',
            Italian: 'VP o Responsabile Pianificazione & Controllo di Gestione, Group Controller',
            Spanish: 'VP o director de planificación y análisis financieros',
            PortugueseBR: 'Vice-presidente ou Diretor de FP&A',
            SpanishLAD: 'Vicepresidente o Director de FP&A'
        },          
    ],
}

const choose_role = (state, action) => {

    const arrOfRoles = state.EXISTING_ROLES;

    let index;

    arrOfRoles.find(function(obj, idx){        
        
        if(obj.English === action.role){
            index = idx;
        };  
        
        return;
    });

    return updateObject(state, {
        currentRole: action.role,
        currentTxtRole: arrOfRoles[index][action.lang],        
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === actionTypes.CHOOSE_ROLE) {
        return choose_role(state, action);
    }
    return state;
};

export default reducer;
